import React from 'react'

/**
 * Converts email addresses in a string to clickable mailto links.
 *
 * This function scans text for email patterns and converts them to JSX with
 * proper mailto links.
 */
export function formatErrorMessage(message: string): React.ReactNode {
  // Email regex pattern to detect email addresses
  const emailRegex = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/gi

  // Split by emails while keeping them in the result
  const parts = message.split(emailRegex)

  return (
    <>
      {parts.map((part, index) => {
        // Check if this part is an email
        if (part.match(emailRegex)) {
          return (
            <a
              key={index}
              href={`mailto:${part}`}
              data-testid={`link_email_${part.split('@')[0]}`}
            >
              {part}
            </a>
          )
        }
        return <React.Fragment key={index}>{part}</React.Fragment>
      })}
    </>
  )
}
